import { getTransferData } from './getTransferData';

type ApiDeclaration = {
    getTransferData: typeof getTransferData;
};

export const initializeAppApiDeclaration: ApiDeclaration = {
    getTransferData
};
